module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticStyle: {
      "background": "#000",
      "height": "100vh"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "score-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-head-body"
  }, [_c('div', {
    staticClass: "score-head-line score-head-line--title"
  }, [_vm._v("\n          " + _vm._s(_vm.row.saiqu_name) + _vm._s(_vm.row.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "score-head-line score-head-line--subject"
  }, [_vm._v("\n          " + _vm._s(_vm.subjectRow.subject_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "score-head-team-row"
  }, [_c('span', {
    staticClass: "score-head-mingcheng"
  }, [_vm._v(_vm._s(_vm.subjectRow.mingcheng))]), _vm._v(" "), (_vm.subjectRow && _vm.subjectRow.id) ? _c('span', {
    staticClass: "score-head-jianlu-inline"
  }, [_c('span', {
    class: _vm.jianluHeadStatusClass
  }, [_vm._v(_vm._s(_vm.jianluHeadStatusText))]), _vm._v(" "), (Number(_vm.subjectRow.jianlu_status) === 6 && _vm.subjectRow.jianlu_note) ? _c('span', {
    staticClass: "score-head-jianlu-note-inline"
  }, [_vm._v(_vm._s(_vm.subjectRow.jianlu_note))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "score-content flex-start"
  }, [_c('div', {
    staticClass: "score-content-left"
  }, [_c('div', {
    staticClass: "score-content-operate"
  }, [_vm._l((_vm.caipan), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "score-li",
      on: {
        "click": function($event) {
          return _vm.onScoreOperate(index + 1)
        }
      }
    }, [_c('div', {
      staticClass: "score-li-box"
    }, [_c('div', {
      staticClass: "caipan-info",
      class: item.status != 1 ? 'caipan-info-disabled' : ''
    }, [_c('div', {
      staticClass: "caipan-name"
    }, [_vm._v("\n                  裁判" + _vm._s(index + 1) + "(" + _vm._s(item.name) + ") \n                ")]), _vm._v(" "), _c('div', {
      staticClass: "caipan-score"
    }, [_vm._v(_vm._s(_vm.subjectRow['score' + (index + 1)]) + "\n                "), (_vm.subjectRow['score_fix_' + (index + 1)] == 'add') ? _c('van-icon', {
      staticStyle: {
        "transform": "rotate(-90deg)"
      },
      attrs: {
        "name": "play",
        "color": "#f00"
      }
    }) : (_vm.subjectRow['score_fix_' + (index + 1)] == 'pen') ? _c('van-icon', {
      staticStyle: {
        "transform": "rotate(90deg)"
      },
      attrs: {
        "name": "play",
        "color": "#0dac0d"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "caipan-comment"
    }, [_vm._v(_vm._s(_vm.subjectRow['comment' + (index + 1)] ?
      '已评价' : '暂无评语') + "\n                ")])]), _vm._v(" "), _c('div', {
      class: item.status === 1 ? 'caipan-button-active flex-between' : 'caipan-button-disabled flex-center'
    }, [_c('div', {
      staticClass: "caipan-button-li"
    }, [_vm._v("\n                  " + _vm._s(item.status === 1 ? '在线' : '离线') + "\n                ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "score-li"
  }, [_c('div', {
    staticClass: "score-li-box"
  }, [_c('div', {
    staticClass: "caipan-info"
  }, [_c('div', {
    staticClass: "caipan-name"
  }, [_vm._v("加分")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-score"
  }, [_vm._v(_vm._s(_vm.subjectRow['score_add']))]), _vm._v(" "), _c('div', {
    staticClass: "caipan-comment"
  }, [_vm._v(_vm._s(_vm.subjectRow['comment_add'] ? _vm.subjectRow['comment_add'] :
    '暂无评语') + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-li"
  }, [_c('div', {
    staticClass: "score-li-box"
  }, [_c('div', {
    staticClass: "caipan-info"
  }, [_c('div', {
    staticClass: "caipan-name"
  }, [_vm._v("减分")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-score"
  }, [_vm._v(_vm._s(_vm.subjectRow['score_pen']))]), _vm._v(" "), _c('div', {
    staticClass: "caipan-comment"
  }, [_vm._v(_vm._s(_vm.subjectRow['comment_pen'] ? _vm.subjectRow['comment_pen'] :
    '暂无评语') + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-li"
  }, [_c('div', {
    staticClass: "score-li-box"
  }, [_c('div', {
    staticClass: "caipan-info"
  }, [_c('div', {
    staticClass: "caipan-name"
  }, [_vm._v("小分均分")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-score"
  }, [_vm._v(_vm._s(_vm.subjectRow['score_ava'] || 0.0))]), _vm._v(" "), _c('div', {
    staticClass: "caipan-comment"
  }, [_vm._v(_vm._s(_vm.subjectRow['comment_pen'] ? _vm.subjectRow['comment_pen'] :
    '暂无评语') + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-li"
  }, [_c('div', {
    staticClass: "score-li-box"
  }, [_c('div', {
    staticClass: "caipan-info"
  }, [_c('div', {
    staticClass: "caipan-name"
  }, [_vm._v("高级裁判组得分")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-score"
  }, [_vm._v(_vm._s(_vm.subjectRow['score_s']))]), _vm._v(" "), _c('div', {
    staticClass: "caipan-comment"
  }, [_vm._v(_vm._s(_vm.subjectRow['comment_pen'] ? _vm.subjectRow['comment_pen'] :
    '暂无评语') + "\n                ")])])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "score-content-right"
  }, [_c('div', {
    staticClass: "content-right-head flex-between"
  }, [_c('div', {
    staticClass: "right-head-li",
    class: _vm.subjectRow.jgroup === 1 ? 'right-head-li-disabled' : ''
  }, [_vm._v("\n            A组裁判" + _vm._s(_vm.caipanListA.length > 0 ? parseInt(_vm.currentIndex) + 1 + '/' + _vm.scoreList.length : '0/0') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "right-head-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-head-li",
    class: _vm.subjectRow.jgroup === 0 ? 'right-head-li-disabled' : ''
  }, [_vm._v("\n            B组裁判" + _vm._s(_vm.caipanListB.length > 0 ? parseInt(_vm.currentIndex) + 1 + '/' + _vm.scoreList.length : '0/0') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right-body-score"
  }, [_vm._v("\n            " + _vm._s(_vm.subjectRow.score_total) + "\n          ")])]), _vm._v(" "), (_vm.subjectRow.current) ? _c('div', {
    staticClass: "content-right-foot content-right-foot-start"
  }, [(_vm.subjectRow.status == 1) ? _c('div', {
    staticClass: "content-right-foot"
  }, [_vm._v("提交分数")]) : (_vm.subjectRow.status == 2) ? _c('div', {
    staticClass: "content-right-foot content-right-foot-started"
  }, [_vm._v("\n            已完成\n          ")]) : (_vm.subjectRow.status == 3) ? _c('div', {
    staticClass: "content-right-foot"
  }, [_vm._v("\n            已弃权\n          ")]) : _vm._e()]) : _c('div', {
    staticClass: "content-right-foot"
  }, [(_vm.subjectRow.status == 3) ? _c('div', {
    staticClass: "content-right-foot-start"
  }, [_vm._v("已弃权")]) : (_vm.subjectRow.status == 2) ? _c('div', {
    staticClass: "content-right-foot content-right-foot-started"
  }, [_vm._v("\n            已完成\n          ")]) : _c('div', {
    staticClass: "content-right-foot content-right-foot-start"
  }, [_vm._v("开始评分")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-foot"
  }, [_c('div', {
    staticClass: "foot-index"
  }, [_vm._v(_vm._s(parseInt(_vm.currentIndex) + 1) + " / " + _vm._s(_vm.scoreList.length))]), _vm._v(" "), _c('div', {
    staticClass: "foot-content flex-between"
  }, [(_vm.currentIndex === 0) ? _c('img', {
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-score-left-disabled.png",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-score-left.png"
    },
    on: {
      "click": _vm.onSubjectPrev
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foot-li-box flex-start"
  }, _vm._l((_vm.scoreList), function(item, index) {
    return _c('div', {
      key: item.id,
      style: ('width: ' + 100 / _vm.scoreList.length + '%')
    }, [(item.status == 2) ? _c('div', {
      staticClass: "foot-li foot-li-active",
      class: index == _vm.currentIndex ? 'foot-li-selected' : ''
    }, [_vm._v(_vm._s(index + 1) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('div', {
      staticClass: "foot-li foot-li-fail",
      class: index == _vm.currentIndex ? 'foot-li-selected' : ''
    }, [_vm._v(_vm._s(index + 1) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "foot-li",
      class: index == _vm.currentIndex ? 'foot-li-selected' : ''
    }, [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.currentIndex === _vm.scoreList.length - 1) ? _c('img', {
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-score-right-disabled.png",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "https://static.dierqudao.com/images/cca/icon-score-right.png",
      "alt": ""
    },
    on: {
      "click": _vm.onSubjectNext
    }
  })])])]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "正在进行"
    },
    model: {
      value: (_vm.actionshow),
      callback: function($$v) {
        _vm.actionshow = $$v
      },
      expression: "actionshow"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "上调分数"
    },
    on: {
      "click": function($event) {
        return _vm.onReSetScore('add')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "下调分数"
    },
    on: {
      "click": function($event) {
        return _vm.onReSetScore('pen')
      }
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo",
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "left": "50px"
    }
  }, [_c('div', {
    staticClass: "score-logo-box",
    staticStyle: {
      "padding": "2px",
      "border-radius": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "45px",
      "height": "45px",
      "border-radius": "100%",
      "border": "2px solid #fff"
    },
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-body-top flex-between"
  }, [_c('div', [_vm._v("总得分")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63293904","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/CommonScoreCheck.vue
// module id = 2441
// module chunks = 0